// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-timeline {
  padding: 20px;
  border-radius: 8px;
  border: 1px solid var(--bs-border-color);
}

.timeline-bar {
  position: relative;
  margin-left: 30px;
  padding-left: 20px;
  border-left: 4px solid #ddd;
}

.timeline-step {
  position: relative;
  margin-bottom: 30px;
  padding-left: 20px;
}

.timeline-step:last-child {
  margin-bottom: 0;
}

.timeline-icon {
  position: absolute;
  top: 0;
  left: -34px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  line-height: 24px;
  background-color: #ddd;
  color: #fff;
  font-weight: bold;
}

.timeline-step.completed .timeline-icon {
  background-color: #ea3377; /* Green for completed */
}

.timeline-step.upcoming .timeline-icon {
  background-color: #6c757d; /* Gray for upcoming */
}

.timeline-content h5 {
  margin-bottom: 10px;
  font-weight: bold;
}

.timeline-content ul {
  list-style: none;
  padding: 0;
}

.timeline-content li {
  margin-bottom: 5px;
}

.timeline-content li input {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".vertical-timeline {\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid var(--bs-border-color);\n}\n\n.timeline-bar {\n  position: relative;\n  margin-left: 30px;\n  padding-left: 20px;\n  border-left: 4px solid #ddd;\n}\n\n.timeline-step {\n  position: relative;\n  margin-bottom: 30px;\n  padding-left: 20px;\n}\n\n.timeline-step:last-child {\n  margin-bottom: 0;\n}\n\n.timeline-icon {\n  position: absolute;\n  top: 0;\n  left: -34px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 24px;\n  background-color: #ddd;\n  color: #fff;\n  font-weight: bold;\n}\n\n.timeline-step.completed .timeline-icon {\n  background-color: #ea3377; /* Green for completed */\n}\n\n.timeline-step.upcoming .timeline-icon {\n  background-color: #6c757d; /* Gray for upcoming */\n}\n\n.timeline-content h5 {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.timeline-content ul {\n  list-style: none;\n  padding: 0;\n}\n\n.timeline-content li {\n  margin-bottom: 5px;\n}\n\n.timeline-content li input {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
